import React from 'react';
import { Chip, Popover, Box, Button } from '@mui/material';
import { CalendarMonth as CalendarIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../themes/typography';

const PERIOD_OPTIONS = [7, 14, 30, 60];

const PeriodPicker = ({ period, onPeriodChange }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <>
      <Chip
        icon={<CalendarIcon sx={{ fontSize: 14 }} />}
        label={t('machines_periodLast', { days: period })}
        deleteIcon={<ExpandMoreIcon sx={{ fontSize: 16 }} />}
        onDelete={(e) => setAnchorEl(e.currentTarget.closest('.MuiChip-root'))}
        size="small"
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          height: 26,
          fontSize: '11px',
          fontWeight: 600,
          cursor: 'pointer',
          borderColor: colors.primary.main,
          color: colors.primary.main,
          '& .MuiChip-icon': { ml: '6px', color: colors.primary.main },
          '& .MuiChip-label': { px: '6px' },
          '& .MuiChip-deleteIcon': { mr: '2px', color: colors.primary.main },
          '&:hover': { backgroundColor: `${colors.primary.main}08` }
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: { borderRadius: '8px', p: 1, mt: 0.5 }
        }}
      >
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {PERIOD_OPTIONS.map((days) => (
            <Button
              key={days}
              size="small"
              variant={period === days ? 'contained' : 'outlined'}
              onClick={() => {
                onPeriodChange(days);
                setAnchorEl(null);
              }}
              sx={{
                minWidth: 40,
                px: 1,
                py: 0.5,
                fontSize: '12px',
                textTransform: 'none',
                fontWeight: period === days ? 700 : 500
              }}
            >
              {t(`machines_period${days}d`)}
            </Button>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default React.memo(PeriodPicker);
